// Instância Axios dedicada à API de Títulos (geração de boleto/PIX das taxas
// dos pedidos de Requerimentos). Autenticação só por x-api-key — diferente de
// protocoloApi/documentosApi, essa API não usa o JWT da sessão do portal, então
// não tem interceptor de Bearer nem de logout em 401 (um 401 aqui não significa
// sessão expirada, só x-api-key inválida).

import axios from 'axios';

const titulosApi = axios.create({
  baseURL: process.env.REACT_APP_TITULOS_API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': process.env.REACT_APP_TITULOS_API_KEY
  }
});

export default titulosApi;
